import React from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import { isArray } from 'lodash'
import clsx from 'clsx'
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from '@material-ui/core'

import { BaseDialog } from 'components'

import useStyles from './styles'

const BaseComponent = ({ item, classes, handleRedirect }) => {
  return (
    <Card className={classes.card}>
      <CardActionArea
        className={classes.cardActionArea}
        onClick={() => handleRedirect(item?.route())}
      >
        <CardContent className={classes.cardContent}>
          <Box className={classes.container}>
            <Box className={classes.baseItems} justifyContent="end">
              {item?.icon && <item.icon size={30} />}
              <Typography variant="h5">{item.title}</Typography>
            </Box>
            <Box className={classes.baseItems} justifyContent="start">
              {isArray(item?.content) ? (
                <ul className={clsx(classes.text, classes.orderedList)}>
                  {item?.content?.map((contentItem, idx) => (
                    <Typography component="li" key={idx}>
                      {contentItem}
                    </Typography>
                  ))}
                </ul>
              ) : (
                <Typography className={classes.text}>{item.content}</Typography>
              )}
            </Box>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

const ServiceTypeDialog = ({
  open,
  setOpen,
  title = '',
  items = [],
  gridItemProps = { xs: 12, md: 6, lg: 3 },
  containerProps = {},
  useCustomGrid = false,
  ...rest
}) => {
  const classes = useStyles()
  const history = useHistory()

  const handleRedirect = (route) => history.push(route)

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title={title}
      dialogSize="lg"
      closeIconButton
      withoutBottomDivider
      {...rest}
    >
      <Box py={2}>
        {useCustomGrid ? (
          <Box
            className={clsx(
              classes.customGridContainer,
              containerProps?.className,
            )}
            {...containerProps}
          >
            {items.map((item, index) => (
              <Box key={index}>
                <BaseComponent
                  item={item}
                  classes={classes}
                  handleRedirect={handleRedirect}
                />
              </Box>
            ))}
          </Box>
        ) : (
          <Grid
            container
            spacing={2}
            justifyContent="center"
            {...containerProps}
          >
            {items.map((item, index) => (
              <Grid item key={index} {...gridItemProps}>
                <BaseComponent
                  item={item}
                  classes={classes}
                  handleRedirect={handleRedirect}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </BaseDialog>
  )
}

ServiceTypeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  containerProps: PropTypes.object,
  gridItemProps: PropTypes.object,
}

export default ServiceTypeDialog
